import { Check, Loader2, Pencil, X } from "lucide-react";
import styles from "./styles.module.scss";

type WorkspaceOverviewHeaderProps = {
  name: string;
  updatedLabel: string;
  editing: boolean;
  nameDraft: string;
  isUpdating: boolean;
  onNameDraft: (value: string) => void;
  onStartEdit: () => void;
  onCancelEdit: () => void;
  onCommit: () => void;
};

export function WorkspaceOverviewHeader({
  name,
  updatedLabel,
  editing,
  nameDraft,
  isUpdating,
  onNameDraft,
  onStartEdit,
  onCancelEdit,
  onCommit,
}: WorkspaceOverviewHeaderProps) {
  return (
    <header className={styles.header}>
      <p className={styles.headerSubtitle}>Overview</p>
      {editing ? (
        <div className={styles.renameRow}>
          <input
            autoFocus
            value={nameDraft}
            onChange={(event) => onNameDraft(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") onCommit();
              if (event.key === "Escape") onCancelEdit();
            }}
            className={styles.renameInput}
            disabled={isUpdating}
          />
          <button
            type="button"
            onClick={onCommit}
            className={styles.renameBtnSave}
            disabled={isUpdating}
          >
            {isUpdating ? <Loader2 size={16} className="spin-animation" /> : <Check size={16} />}
          </button>
          <button
            type="button"
            onClick={onCancelEdit}
            className={styles.renameBtnCancel}
            disabled={isUpdating}
          >
            <X size={16} />
          </button>
        </div>
      ) : (
        <div className={styles.titleRow}>
          <h2 className={styles.title}>{name}</h2>
          <button type="button" onClick={onStartEdit} className={styles.renameBtn}>
            <Pencil size={12} /> Rename
          </button>
        </div>
      )}
      <p className={styles.metaText}>Updated {updatedLabel}</p>
    </header>
  );
}
